import React from 'react';
import { Typography } from 'antd';
import './WelcomeSection.css';

// Import avatar image
import aiRobotIcon from "../assets/images/ai_robot.png";

const { Text } = Typography;

interface WelcomeSectionProps {
    title?: string;
    subtitle?: string;
}

const WelcomeSection: React.FC<WelcomeSectionProps> = ({
    title = "Hi, 我是您的福利顾问助手",
    subtitle = `福利方案设计、产品方案介绍、福利政策解读`
}) => {
    return (
        <div className="welcome-section">
            {/* 头像区域 */}
            <div className="avatar-container">
                <img
                    className="assistant-avatar"
                    src={aiRobotIcon}
                    alt="福利顾问"
                    width={80}
                    height={80}
                />
            </div>

            {/* 欢迎文本 */}
            <div className="welcome-text">
                <Text className="welcome-title">{title}</Text>
                <Text className="welcome-subtitle">
                    {subtitle}<br />
                    您可以试试这么问
                </Text>
            </div>
        </div>
    );
};

export default WelcomeSection; 